import { formatPrice } from '@common/utils/format-price/format-price.util';
import React from 'react';
import 'twin.macro';

export const Item = ({
    title,
    quantity,
    price,
    percentage_discount,
    className,
}: {
    title: string;
    quantity?: number;
    price?: number;
    percentage_discount?: string;
    className?: string;
}): JSX.Element => {
    return (
        <div tw="flex justify-between font-light" className={className}>
            <div data-testid="title" tw="text-base">
                {quantity && <strong>{quantity}x </strong>}
                {title}
            </div>
            <div data-testid="weight" tw="text-base">
                {percentage_discount ? percentage_discount : formatPrice(price || 0)}
            </div>
        </div>
    );
};
